/* radio.tsx generated by @compiled/babel-plugin v3.0.2 */
/// <reference types="node" />
// for typing `process`
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._0hPCNLchRC%7Balign-items%3Aflex-start%7D%0A._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._1UtDYzot27%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._0wOv4Qsyl5%7Bcursor%3Anot-allowed%7D%0A._2XghbEPgdg%7Bmargin%3Avar(--ds-space-0%2C0)%7D%0A._30huDKUwEI%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20var(--radio-border-color)%7D%0A._0bjKvDaaQb%7Bborder-radius%3Avar(--ds-radius-full%2C50%25)%7D%0A._2xIroY98eZ%7Boutline-color%3AcurrentColor%7D%0A._497WNwYbGa%7Boutline-style%3Anone%7D%0A._2zndICT6kp%7Boutline-width%3Amedium%7D%0A._23rrnHWkmS%7Btransition%3Aborder-color%20.2s%20ease-in-out%2Cbackground-color%20.2s%20ease-in-out%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._0KLXruG2s3%7Bbackground-color%3Avar(--radio-background-color)%7D%0A._2B7VO8YbGa%7B-moz-appearance%3Anone%7D%0A._46tpOU7Cj1%7B--radio-background-color%3Avar(--ds-background-input%2C%23fff)%7D%0A._2rYKcAHKt7%7B--radio-border-color%3Avar(--ds-border-input%2C%238c8f97)%7D%0A._07ionz6BYM%7B--radio-dot-color%3Avar(--ds-icon-inverse%2C%23fff)%7D%0A._1XF9ANdnbC%7B--radio-dot-opacity%3A0%7D%0A._1VJPcaGquZ%7Btransform%3Ascale(.625)%7D%0A._1RrJLiBwqQ%7Bvertical-align%3Atop%7D%0A._2adT7gYbGa%7B-webkit-appearance%3Anone%7D%0A._2OWEWsdaW3%3Aafter%7Bbackground%3Avar(--radio-dot-color)%7D%0A._2Gfj6iaaQb%3Aafter%7Bborder-radius%3Avar(--ds-radius-full%2C50%25)%7D%0A._1JM8vvueoN%3Aafter%7Btransition%3Abackground-color%20.2s%20ease-in-out%2Copacity%20.2s%20ease-in-out%7D%0A._2jfUf9yaFJ%3Aafter%7Bwidth%3A.6pc%7D%0A._47eTBtyaFJ%3Aafter%7Bheight%3A.6pc%7D%0A._2WYcYGWVPG%3Aafter%7Bposition%3Aabsolute%7D%0A._0GBAIrogpp%3Aafter%7Bcontent%3A%22%22%7D%0A._43i6GSTJun%3Aafter%7Bopacity%3Avar(--radio-dot-opacity)%7D%0A._23rrnHnc7r%7Btransition%3Avar(--ds-input-selection%2Cbackground-color%20border-color%20color%20fill%20stroke%20opacity%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._1JM8vvnc7r%3Aafter%7Btransition%3Avar(--ds-input-selection%2Cbackground-color%20border-color%20color%20fill%20stroke%20opacity%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A%40media%20(forced-colors%3Aactive)%7B._1QEw40YbGa%3Aafter%7Btransition%3Anone%7D%7D%0A._2tbAUcYbGa%3Aafter%7Bpointer-events%3Anone%7D%0A%40media%20(forced-colors%3Aactive)%7B._3wrwGmYbGa%7Btransition%3Anone%7D%7D%0A._1etv9ykLmD%3Achecked%7B--radio-background-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D%0A._2tFSPOkLmD%3Achecked%7B--radio-border-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D%0A._0ZLH27HZdu%3Achecked%7B--radio-dot-opacity%3A1px%7D%0A._2fqI0WXzJH%3Afocus%7Boutline%3Avar(--ds-border-width-focused%2C2px)%20solid%20var(--ds-border-focused%2C%234688ec)%7D%0A._38a67R4Y4b%3Afocus%7Boutline-offset%3A3px%7D%0A._0rUt1uXzJH%3Achecked%3Afocus%7Boutline%3Avar(--ds-border-width-focused%2C2px)%20solid%20var(--ds-border-focused%2C%234688ec)%7D%0A._0IDPPJ4Y4b%3Achecked%3Afocus%7Boutline-offset%3A3px%7D%0A._4dpqOVqWX3%3Ahover%7B--radio-background-color%3Avar(--ds-background-input-hovered%2C%23f8f8f8)%7D%0A._42HvB4HKt7%3Ahover%7B--radio-border-color%3Avar(--ds-border-input%2C%238c8f97)%7D%0A._2bmooNXLOx%3Achecked%3Ahover%7B--radio-background-color%3Avar(--ds-background-selected-bold-hovered%2C%231558bc)%7D%0A._3CIMOkXLOx%3Achecked%3Ahover%7B--radio-border-color%3Avar(--ds-background-selected-bold-hovered%2C%231558bc)%7D%0A._1SLx5PutHW%3Aactive%7B--radio-background-color%3Avar(--ds-background-input-pressed%2C%23fff)%7D%0A._1hb6ILPSfI%3Achecked%3Aactive%7B--radio-background-color%3Avar(--ds-background-selected-bold-pressed%2C%23123263)%7D%0A._3i4XoaHKt7%3Achecked%3Aactive%7B--radio-border-color%3Avar(--ds-border-input%2C%238c8f97)%7D%0A._0oAkhw6BYM%3Achecked%3Aactive%7B--radio-dot-color%3Avar(--ds-icon-inverse%2C%23fff)%7D%0A._46tpOUVrZW%7B--radio-background-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._2rYKcAhQC5%7B--radio-border-color%3Avar(--ds-border-disabled%2C%230515240f)%7D%0A._07ionzoM2E%7B--radio-dot-color%3Avar(--ds-icon-disabled%2C%23080f214a)%7D%0A._1XF9ANHZdu%7B--radio-dot-opacity%3A1px%7D%0A._2rYKcA7j8z%7B--radio-border-color%3Avar(--ds-icon-danger%2C%23c9372c)%7D%0A._2tFSPO7j8z%3Achecked%7B--radio-border-color%3Avar(--ds-icon-danger%2C%23c9372c)%7D%0A._0xmtkoFQfX%7Bpadding-block-end%3Avar(--ds-space-025%2C2px)%7D%0A._46hvQmFQfX%7Bpadding-block-start%3Avar(--ds-space-025%2C2px)%7D%0A._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D%0A._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");


































































import { forwardRef, memo, type MemoExoticComponent, type Ref } from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import __noop from '@atlaskit/ds-lib/noop';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { type RadioProps } from './types';
const packageName = (process.env._PACKAGE_NAME_ as string);
const packageVersion = (process.env._PACKAGE_VERSION_ as string);
const noop = __noop;
const labelPaddingStyles = null;
const labelStyles = null;
const labelDisabledStyles = null;
const radioBaseStyles = null;
const radioInteractiveStyles = null;
const radioDisabledStyles = null;
const radioDisabledCheckedStyles = null;
const radioInvalidStyles = null;

// Preserve the input's zoom correction and focus outline while cross-fading states.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const crossFadeStyles = null;
const InnerRadio: React.ForwardRefExoticComponent<React.PropsWithoutRef<RadioProps> & React.RefAttributes<HTMLInputElement>> = forwardRef(function Radio(props: RadioProps, ref: Ref<HTMLInputElement>) {
  const {
    ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    isDisabled = false,
    isRequired,
    isInvalid = false,
    isChecked = false,
    label,
    labelId,
    name,
    onChange = noop,
    value,
    testId,
    analyticsContext,
    // events and all other input props
    ...rest
  } = props;
  const onChangeAnalytics = usePlatformLeafEventHandler({
    fn: onChange,
    action: 'changed',
    analyticsData: analyticsContext,
    componentName: 'radio',
    packageName,
    packageVersion
  });
  return <label data-testid={testId && `${testId}--radio-label`} data-disabled={isDisabled ? 'true' : undefined} className={ax(["_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _1mT5xdRAKS _0hPCNLchRC _1UtDYzy7kJ", isDisabled && "_1UtDYzot27 _0wOv4Qsyl5"])}>
			{/* eslint-disable-next-line @atlaskit/design-system/no-html-radio */}
			<input {...rest}
    // It is necessary only for Safari. It allows to render focus styles.
    tabIndex={0} aria-label={ariaLabel}
    // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
    aria-labelledby={labelId || ariaLabelledBy} checked={isChecked} disabled={isDisabled} name={name} onChange={onChangeAnalytics} required={isRequired} type="radio" value={value} data-testid={testId && `${testId}--radio-input`}
    // isInvalid is used in a nonstandard way so cannot
    // use :invalid selector
    data-invalid={isInvalid ? 'true' : undefined} ref={ref} className={ax(["_2XghbEPgdg _30huDKUwEI _0bjKvDaaQb _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHWkmS _3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0KLXruG2s3 _2B7VO8YbGa _46tpOU7Cj1 _2rYKcAHKt7 _07ionz6BYM _1XF9ANdnbC _1VJPcaGquZ _1RrJLiBwqQ _2adT7gYbGa _2OWEWsdaW3 _2Gfj6iaaQb _1JM8vvueoN _2jfUf9yaFJ _47eTBtyaFJ _2WYcYGWVPG _0GBAIrogpp _43i6GSTJun", fg('platform_design_system_selection_radial_fade') && "_23rrnHnc7r _1JM8vvnc7r _1QEw40YbGa _2tbAUcYbGa _3wrwGmYbGa", !isDisabled && "_1etv9ykLmD _2tFSPOkLmD _0ZLH27HZdu _2fqI0WXzJH _38a67R4Y4b _0rUt1uXzJH _0IDPPJ4Y4b _4dpqOVqWX3 _42HvB4HKt7 _2bmooNXLOx _3CIMOkXLOx _1SLx5PutHW _1hb6ILPSfI _3i4XoaHKt7 _0oAkhw6BYM", isDisabled && "_0wOv4Qsyl5 _46tpOUVrZW _2rYKcAhQC5 _07ionzoM2E", isDisabled && isChecked && "_1XF9ANHZdu", isInvalid && !isDisabled && "_2rYKcA7j8z _2tFSPO7j8z"])} />
			{label ? <span className={ax(["_0xmtkoFQfX _46hvQmFQfX _03SyCP1Y8M _0LQT5E1Y8M"])}>{label}</span> : null}
		</label>;
});

/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */
const Radio: MemoExoticComponent<React.ForwardRefExoticComponent<React.PropsWithoutRef<RadioProps> & React.RefAttributes<HTMLInputElement>>> = memo(forwardRef(function Radio(props: RadioProps, ref: Ref<HTMLInputElement>) {
  return <InnerRadio {...props} ref={ref} />;
}));
export default Radio;